import React from "react"
import { imageProps } from "aldoo-ra/CMS/url"
import { HERO_SIZES } from "../hero-sizes"

const HeaderSectionRight = ({ data }) => {
  if (!data || !data.images || !data.images[0]) return null
  
  return (
    <div className="w-full md:w-[45%] lg:w-[45%] xl:w-[50%] flex flex-col items-center md:items-start xl:items-end md:justify-end mx-auto">
      <div className="w-full max-w-[420px] md:max-w-[350px] lg:max-w-[450px] xl:max-w-[600px] aspect-1351/968 md:pt-[50px] xl:pt-6 lg:mt-0">
        <img {...imageProps(data.images[0], HERO_SIZES)} alt="Windows Device" fetchPriority="high" className="w-full h-auto" />
      </div>
    </div>
  )
}

export default HeaderSectionRight
